<nz-layout>
    <nz-content>
        <form [formGroup]="orderForm">
            <div class="header">
                <p class="font-bold text-lg">Create Order</p>
                <div class="actions">
                    <label
                        nz-checkbox
                        [(ngModel)]="isDraftOrder"
                        [ngModelOptions]="{ standalone: true }"
                        class="mr-4 flex items-center"
                    >
                        Pay Later
                    </label>
                    <label
                        nz-checkbox
                        [(ngModel)]="sendEvent"
                        [ngModelOptions]="{ standalone: true }"
                        class="mr-4 flex items-center"
                    >
                        Send Event (trigger order.created)
                    </label>
                    <button nz-button nzType="default">Cancel</button>
                    <button
                        nz-button
                        nzType="primary"
                        (click)="submit()"
                        [disabled]="
                            !orderForm.valid ||
                            isSubmitting ||
                            items.length === 0
                        "
                    >
                        Create Order
                    </button>
                    <p class="error" *ngIf="error">
                        {{ error }}
                    </p>
                </div>
            </div>
            <nz-divider></nz-divider>
            <div formArrayName="items">
                <nz-table
                    #basicTable
                    [nzData]="items.controls"
                    [nzLoading]="isLoading"
                    [nzShowPagination]="false"
                >
                    <thead>
                        <tr>
                            <th style="min-width: 180px">Product</th>
                            <th style="min-width: 120px">Options</th>
                            <th style="width: 48px">Qty/Cycle(s)</th>
                            <th style="width: 80px">Sale Price</th>
                            <th style="width: 80px">Discount</th>
                            <th style="width: 80px; text-align: center">
                                <div
                                    style="
                                        display: flex;
                                        flex-direction: column;
                                        align-items: center;
                                    "
                                >
                                    <span>Drug Price</span>
                                    <span style="font-size: 10px; color: #888"
                                        >(per Unit)</span
                                    >
                                </div>
                            </th>
                            <th style="min-width: 80px">Visit Fee</th>
                            <th style="min-width: 80px">Shipping Fee</th>
                            <th style="min-width: 120px; max-width: 260px">
                                Insurance Coverage
                            </th>
                            <th style="width: 80px">Subtotal</th>
                            <th style="width: 40px"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container
                            [formGroupName]="i"
                            *ngFor="let item of basicTable.data; let i = index"
                        >
                            <tr>
                                <td style="min-width: 180px">
                                    {{ item.value.name }}
                                    <nz-tag
                                        *ngIf="
                                            item.value.isSubscription;
                                            else oneTime
                                        "
                                        nzColor="green"
                                        class="ml-2"
                                        >Subscription</nz-tag
                                    >
                                    <ng-template #oneTime>
                                        <nz-tag nzColor="blue">One-Time</nz-tag>
                                    </ng-template>
                                    <nz-tag *ngIf="item.value.isSubscription">{{
                                        lastPhase(item.value.subscriptionPhases)
                                    }}</nz-tag>
                                </td>
                                <td style="min-width: 120px">
                                    <div class="options-container">
                                        <ng-container
                                            *ngFor="
                                                let optionCtrl of item.get(
                                                    'options'
                                                ).controls;
                                                let optionIndex = index
                                            "
                                        >
                                            <div class="option-item">
                                                <label class="option-label"
                                                    >{{
                                                        optionCtrl.get('type')
                                                            .value
                                                    }}:</label
                                                >
                                                <nz-select
                                                    [formControl]="
                                                        optionCtrl.get('value')
                                                    "
                                                    class="option-select"
                                                >
                                                    <nz-option
                                                        *ngFor="
                                                            let choice of optionCtrl.get(
                                                                'choices'
                                                            ).value
                                                        "
                                                        [nzValue]="choice.value"
                                                        [nzLabel]="choice.label"
                                                    ></nz-option>
                                                </nz-select>
                                            </div>
                                        </ng-container>
                                    </div>
                                </td>
                                <td style="width: 48px">
                                    <nz-input-number
                                        formControlName="quantity"
                                        [nzMin]="1"
                                        class="quantity-input"
                                    />
                                </td>
                                <td style="width: 80px">
                                    <nz-input-number
                                        formControlName="salePrice"
                                        [nzMin]="0"
                                        class="price-input"
                                        (input)="
                                            onDecimalInput(
                                                $event,
                                                item.get('salePrice')
                                            )
                                        "
                                    />
                                </td>
                                <td style="width: 80px">
                                    <nz-input-number
                                        formControlName="discount"
                                        [nzMin]="0"
                                        class="discount-input"
                                        (input)="
                                            onDecimalInput(
                                                $event,
                                                item.get('discount')
                                            )
                                        "
                                    />
                                </td>
                                <td style="width: 80px">
                                    <nz-input-number
                                        formControlName="drugPrice"
                                        [nzMin]="0"
                                        class="drug-price-input"
                                        (input)="
                                            onDecimalInput(
                                                $event,
                                                item.get('drugPrice')
                                            )
                                        "
                                    />
                                </td>
                                <td style="min-width: 80px">
                                    <nz-input-number
                                        formControlName="visitFee"
                                        [nzMin]="0"
                                        class="visit-fee-input"
                                        (input)="
                                            onDecimalInput(
                                                $event,
                                                item.get('visitFee')
                                            )
                                        "
                                    />
                                </td>
                                <td style="min-width: 80px">
                                    <nz-input-number
                                        formControlName="shippingFee"
                                        [nzMin]="0"
                                        class="shipping-fee-input"
                                        (input)="
                                            onDecimalInput(
                                                $event,
                                                item.get('shippingFee')
                                            )
                                        "
                                    />
                                </td>
                                <td
                                    style="
                                        min-width: 120px;
                                        max-width: 260px;
                                        vertical-align: middle;
                                    "
                                >
                                    <div
                                        class="insurance-coverages-cell"
                                        formArrayName="insuranceCoverages"
                                    >
                                        <ng-container
                                            *ngFor="
                                                let insurance of item.get(
                                                    'insuranceCoverages'
                                                ).controls;
                                                let insuranceIndex = index
                                            "
                                            [formGroupName]="insuranceIndex"
                                        >
                                            <div class="insurance-entry">
                                                <nz-select
                                                    formControlName="type"
                                                    class="insurance-type-select"
                                                    nzPlaceHolder="Select Insurance"
                                                >
                                                    <nz-option
                                                        *ngFor="
                                                            let type of insuranceTypes
                                                        "
                                                        [nzValue]="type.key"
                                                        [nzLabel]="type.label"
                                                    ></nz-option>
                                                </nz-select>
                                                <nz-input-number
                                                    formControlName="amount"
                                                    [nzMin]="0"
                                                    class="insurance-amount-input"
                                                    placeholder="Amount"
                                                    (input)="
                                                        onDecimalInput(
                                                            $event,
                                                            insurance.get(
                                                                'amount'
                                                            )
                                                        )
                                                    "
                                                />
                                                <button
                                                    nz-button
                                                    nzType="text"
                                                    (click)="
                                                        removeInsurance(
                                                            i,
                                                            insuranceIndex
                                                        )
                                                    "
                                                    class="remove-insurance"
                                                >
                                                    <i
                                                        class="fa-solid fa-x"
                                                    ></i>
                                                </button>
                                            </div>
                                        </ng-container>
                                        <button
                                            nz-button
                                            nzType="dashed"
                                            (click)="addInsurance(i)"
                                            class="add-insurance-btn"
                                        >
                                            <i
                                                class="fa-solid fa-plus mr-2"
                                            ></i>
                                            Add Insurance
                                        </button>
                                    </div>
                                </td>
                                <td style="width: 80px">
                                    {{ calculateSubTotal(item) }}
                                </td>
                                <td style="width: 40px">
                                    <a
                                        href="javascript:void(0)"
                                        (click)="removeProduct(i)"
                                    >
                                        <i class="fa-solid fa-trash"></i>
                                    </a>
                                </td>
                            </tr>
                            <tr *ngIf="item.invalid">
                                <td
                                    colspan="11"
                                    class="error-messages-container"
                                >
                                    <div
                                        class="error-message text-left"
                                        *ngIf="item.get('quantity').errors?.['subscriptionQuantityExceeded']"
                                    >
                                        Quantity cannot be more than 1 for
                                        subscription products
                                    </div>
                                    <div
                                        class="error-message text-left"
                                        *ngIf="item.get('quantity').errors?.['maxCycles']"
                                    >
                                        Cycles cannot exceed
                                        {{ item.get('quantity').errors?.['maxCycles'].max }}
                                        for this subscription
                                    </div>
                                    <div
                                        class="error-message text-left"
                                        *ngIf="item.get('salePrice').errors?.['drugPriceExceedsSalePrice']"
                                    >
                                        Drug price cannot exceed the total sale
                                        price
                                    </div>
                                    <div
                                        class="error-message text-left"
                                        *ngIf="item.get('discount').errors?.['discountExceedsMax']"
                                    >
                                        Discount cannot exceed the total price
                                        or (Sale Price - Drug Price)
                                    </div>
                                    <div
                                        class="error-message text-left"
                                        *ngIf="item.get('drugPrice').errors?.['drugPriceExceedsSalePrice']"
                                    >
                                        Drug price cannot exceed the total sale
                                        price
                                    </div>
                                    <div
                                        class="error-message text-left"
                                        *ngIf="isInsuranceMaxed(i)"
                                    >
                                        Total insurance coverage cannot exceed
                                        the drug price
                                    </div>
                                    <ng-container
                                        *ngFor="
                                            let insurance of item.get(
                                                'insuranceCoverages'
                                            ).controls
                                        "
                                    >
                                        <div
                                            class="error-message text-left"
                                            *ngIf="insurance.get('type').errors?.['required']"
                                        >
                                            Insurance type is required
                                        </div>
                                        <div
                                            class="error-message text-left"
                                            *ngIf="insurance.get('amount').errors?.['insuranceExceedsPrice']"
                                        >
                                            Insurance coverage cannot exceed the
                                            drug price
                                        </div>
                                    </ng-container>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </nz-table>
            </div>
        </form>
        <div class="add-product-section mt-4">
            <label>Add Product:</label>
            <nz-select
                [(ngModel)]="category"
                [nzLoading]="isLoadingCategories"
                nzSize="large"
                style="width: 150px"
            >
                <nz-option
                    *ngFor="let c of categories"
                    [nzValue]="c.id"
                    [nzLabel]="c.name"
                ></nz-option>
            </nz-select>
            <jackhealth-admin-product-selector
                [category]="category"
                (productSelected)="onProductSelected($any($event))"
            ></jackhealth-admin-product-selector>
        </div>
        <div *ngIf="items.length > 0" class="grid grid-cols-12">
            <td class="col-span-12">
                <div class="totals-container">
                    <div class="total-item" *ngIf="insuranceCoverage > 0">
                        <span class="label">Total Insurance Coverage:</span>
                        <span class="value">{{
                            insuranceCoverage | currency
                        }}</span>
                    </div>
                    <div class="total-item">
                        <span class="label">Total Price:</span>
                        <span class="value">{{ total | currency }}</span>
                    </div>
                </div>
            </td>
        </div>
    </nz-content>
</nz-layout>
